import type { NavLink } from './SiteNav';

export function SiteFooter({ links }: { links: NavLink[] }) {
  return (
    <footer className="footer">
      <div className="wrap footer-inner">
        <div className="footer-brand">
          <span className="footer-brand-dot" />
          vibelibs.dev
        </div>
        <div className="footer-links">
          {links.map((l) => {
            const external = l.href.startsWith('http');
            return (
              <a
                key={l.href}
                href={l.href}
                {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
              >
                {l.label}
              </a>
            );
          })}
        </div>
        <div className="footer-copy">
          © {new Date().getFullYear()} vibelibs. Hand-crafted, not generated.
        </div>
      </div>
    </footer>
  );
}
